import { htmlDecode } from "@hopper-b2b/utilities";

/**
 * Decodes HTML entities in a city/airport name with fallback handling.
 *
 * This utility wraps htmlDecode to:
 * 1. Safely handle null/undefined input (prevents htmlDecode from creating malformed HTML)
 * 2. Provide a clean fallback chain when decoding returns empty string
 *
 * @param encodedCityName - The potentially HTML-encoded city/airport name
 * @param fallbacks - One or more fallback values to use if decoding returns empty
 * @returns The decoded city name, or the first truthy fallback, or empty string
 *
 * @example
 * // Single fallback
 * decodeCityName(airport.cityName, airportCode)
 *
 * @example
 * // Multiple fallbacks
 * decodeCityName(airport.cityName, airport.name, airportCode)
 */
export const decodeCityName = (
  encodedCityName: string | null | undefined,
  ...fallbacks: (string | null | undefined)[]
): string => {
  const decoded = htmlDecode(encodedCityName ?? "");
  if (decoded) return decoded;

  for (const fallback of fallbacks) {
    if (fallback) return fallback;
  }

  return "";
};
